// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function getComputedAbstractSwitchState(checked, disabled, readOnly, indeterminate, defaultValue = 'default') {
    let computedState;
    if (disabled) {
        computedState = 'disabled';
    }
    else if (readOnly) {
        computedState = 'readOnly';
    }
    else if (indeterminate) {
        computedState = 'indeterminate';
    }
    else if (checked) {
        computedState = 'checked';
    }
    else {
        computedState = defaultValue;
    }
    return computedState;
}
//# sourceMappingURL=style.js.map